module.exports = __webpack_public_path__ + "img/warwork_large.91bf4e40.png";